package ui.settings.screens

import androidx.compose.foundation.layout.*
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import com.essntl.config.EssntlConfig
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esTypography

@Composable
fun BackofficeSettingsScreen(
    onRefresh: (() -> Unit) -> Unit,
) {
    val uriHandler = LocalUriHandler.current

    Column(
        modifier = Modifier.fillMaxSize().padding(2.spacing),
        horizontalAlignment = Alignment.Start,
        verticalArrangement = Arrangement.Top
    ) {
        Text(
            text = "Backoffice Settings",
            style = MaterialTheme.esTypography.h3Bold24,
            modifier = Modifier.padding(bottom = 2.spacing)
        )

        Text(
            text = "Access the backoffice portal to manage advanced settings and configurations.",
            style = MaterialTheme.esTypography.p1Regular16,
            modifier = Modifier.padding(bottom = 3.spacing)
        )

        Button(
            onClick = {
                uriHandler.openUri("https://backoffice.odia.app") // Replace with your actual backoffice URL
            }
        ) {
            Text("Open Backoffice Portal")
        }
    }
}